import React, { useState } from 'react';
import './Navbar.css'; // Importing the CSS file
import '../Data'
// import logo
import logoimg from '../assets/images/logo-hospital.png';
import { Link } from 'react-router-dom';
// icons
import { FaPhone, FaEnvelope, FaAmbulance, FaTimes, FaChevronDown } from "react-icons/fa";
function Navbar() {

    const [isOpen, setIsOpen] = useState(false);
    const [isDropdownOpen, setDropdownOpen] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [formData, setFormData] = useState({
        patientName: '',
        mobileNumber: '',
        department: '',
        appointmentDate: '',
        appointmentTime: ''
    });

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const handleSubmit = (e) => {
        e.preventDefault();

        // Validate required fields
        if (!formData.patientName || !formData.mobileNumber || !formData.appointmentDate || !formData.appointmentTime) {
            alert('Please fill in all required fields.');
            return;
        }

        // Create WhatsApp message
        const message = `New Appointment Request:\n\nPatient Name: ${formData.patientName}\nMobile: ${formData.mobileNumber}\nDepartment: ${formData.department}\nDate: ${formData.appointmentDate}\nTime: ${formData.appointmentTime}`;

        // WhatsApp URL
        const whatsappUrl = `https://wa.me/8374062188?text=${encodeURIComponent(message)}`;

        // Open WhatsApp
        window.open(whatsappUrl, '_blank');

        // Close modal and reset form
        setShowModal(false);
        setFormData({
            patientName: '',
            mobileNumber: '',
            department: '',
            appointmentDate: '',
            appointmentTime: ''
        });
    };

    const departments = [
        { value: 'cardiology', label: 'Cardiology' },
        { value: 'orthopaedics', label: 'Orthopaedics' },
        { value: 'pediatrics-neonatal-care', label: 'Pediatrics and Neonatal Care' },
        { value: 'obstetrics-gynaecology', label: 'Obstetrics and Gynaecology' },
        { value: 'general-surgery', label: 'General Surgery' },
        { value: 'neurology', label: 'Neurology' },
        { value: 'gastroenterology', label: 'Gastroenterology' },
        { value: 'pulmonology', label: 'Pulmonology' },
        { value: 'ent', label: 'ENT (Ear, Nose, Throat)' },
        { value: 'dermatology', label: 'Dermatology' },
        { value: 'urology-nephrology', label: 'Urology and Nephrology' },
        { value: 'clinical-laboratory', label: '24/7 Clinical Laboratory' },
        { value: 'pharmacy', label: '24/7 Pharmacy' },
        { value: 'emergency-trauma-care', label: 'Emergency and Trauma Care' },
        { value: 'physiotherapy-rehabilitation', label: 'Physiotherapy and Rehabilitation' },
        { value: 'dentistry', label: 'Dentistry' },
        { value: 'oncology', label: 'Oncology' },
        { value: 'general-services', label: 'General Services' }
    ];

    return (
        <section className='container-fluid g-0'>
            {/* Top Info Bar */}
            <div className="top-info-bar">
                <div className="container">
                    <div className="info-content">
                        <div className="contact-info">
                            <span><FaPhone /> 89140 52667</span>
                            <span><FaEnvelope /> info@jdshospitals.com</span>
                        </div>
                        <div className="emergency">
                            <span className="emergency-text"><FaAmbulance /> Emergency 24/7</span>
                        </div>
                    </div>
                </div>
            </div>
            <div className='container-fluid p-0'>
                <nav className="navbar">
                    <div className="navbar-container">
                        {/* Logo */}
                        <div className="logo">
                            <img src={logoimg} alt="Hospital Logo" />
                        </div>

                        {/* Nav Links */}
                        <ul className={isOpen ? "nav-links active" : "nav-links"}>
                            <li><Link to="/">Home</Link></li>
                            <li><Link to="/Services">Services</Link></li>
                            <li><Link to="/About">About Us</Link></li>
                            <li><Link to="/doctors">Our Doctors</Link></li>
                            <li className="dropdown-container" onClick={() => setDropdownOpen(!isDropdownOpen)}>
                                <span className="nav-link-text">Resources <FaChevronDown className={`dropdown-icon ${isDropdownOpen ? 'rotate' : ''}`} /></span>
                                <ul className={`dropdown-menu ${isDropdownOpen ? 'show' : ''}`}>
                                    <li><Link to="/facilities">Facilities</Link></li>
                                    <li><Link to="/careers">Careers</Link></li>
                                    <li><Link to="/Blog">Our Blogs</Link></li>
                                </ul>
                            </li>
                            <li><Link to="/Contact">Contact</Link></li>
                        </ul>
                        {/* Create Account Button */}
                        <div className="create-account rounded-pill ">
                            <button onClick={() => setShowModal(true)} className="btn text-white fs-6">Book Appointment</button>
                        </div>

                        {/* Toggle Button for Mobile */}
                        <div className="toggle-btn" onClick={() => setIsOpen(!isOpen)}>
                            <span className="bar"></span>
                            <span className="bar"></span>
                            <span className="bar"></span>
                        </div>
                    </div>
                </nav>
            </div>

            {/* Appointment Modal */}
            {showModal && (
                <div className="modal-overlay" onClick={() => setShowModal(false)}>
                    <div className="modal-content" onClick={(e) => e.stopPropagation()}>
                        <div className="modal-header">
                            <h3>Book an Appointment</h3>
                            <button className="close-btn" onClick={() => setShowModal(false)}>
                                <FaTimes />
                            </button>
                        </div>
                        <form onSubmit={handleSubmit} className="appointment-form">
                            <div className="form-group">
                                <label htmlFor="patientName">Patient Name <span className="text-danger">*</span></label>
                                <input
                                    type="text"
                                    id="patientName"
                                    name="patientName"
                                    value={formData.patientName}
                                    onChange={handleInputChange}
                                    required
                                />
                            </div>

                            <div className="form-group">
                                <label htmlFor="mobileNumber">Mobile Number <span className="text-danger">*</span></label>
                                <input
                                    type="tel"
                                    id="mobileNumber"
                                    name="mobileNumber"
                                    value={formData.mobileNumber}
                                    onChange={handleInputChange}
                                    required
                                />
                            </div>

                            <div className="form-group">
                                <label htmlFor="department">Department <span className="text-danger">*</span></label>
                                <select
                                    id="department"
                                    name="department"
                                    value={formData.department}
                                    onChange={handleInputChange}
                                    required
                                >
                                    <option value="">Select Department</option>
                                    {departments.map((dept) => (
                                        <option key={dept.value} value={dept.label}>
                                            {dept.label}
                                        </option>
                                    ))}
                                </select>
                            </div>

                            <div className="form-group">
                                <label htmlFor="appointmentDate">Appointment Date <span className="text-danger">*</span></label>
                                <input
                                    type="date"
                                    id="appointmentDate"
                                    name="appointmentDate"
                                    value={formData.appointmentDate}
                                    onChange={handleInputChange}
                                    required
                                    min={new Date().toISOString().split('T')[0]}
                                />
                            </div>

                            <div className="form-group">
                                <label htmlFor="appointmentTime">Time <span className="text-danger">*</span></label>
                                <input
                                    type="time"
                                    id="appointmentTime"
                                    name="appointmentTime"
                                    value={formData.appointmentTime}
                                    onChange={handleInputChange}
                                    required
                                />
                            </div>

                            <div className="form-actions">
                                <button type="submit" className="submit-btn">
                                    Send on WhatsApp
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            )}
        </section>
    );
};

export default Navbar;

